
import {Component, Prop, Vue} from "vue-property-decorator";
import {BorcluSgkHacizCevap, ISgkHacizSonuc} from "@/plugins/uyap-plugin/uyap/BorcluSgkHaciz";
import SorguKaynakRozeti from "@/components/eicrapro/sorgu/SorguKaynakRozeti.vue";

@Component({
  components: {SorguKaynakRozeti}
})

export default class BorcluSgkHacizPicker extends Vue {
  @Prop({required: true}) dosyaId!: string;
  @Prop({required: true}) kisiKurumId!: number;
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;

  items: Array<ISgkHacizSonuc> = [];
  /**
   * Faz 4 İP3: kaynak rozeti cevabın kendisini okuyor (`snapshotKaynagi`).
   * Cevap sunucu snapshot'ından geldiyse rozet görünür, canlı/IndexedDB'den
   * geldiyse hiç render edilmez.
   */
  cevap: BorcluSgkHacizCevap | null = null;
  yenileniyor = false;

  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  created() {
    this.load();
  }

  async load(tazele: boolean = false) {
    const talep = {dosyaId: this.dosyaId, kisiKurumId: this.kisiKurumId};
    // `fresh()` hem IndexedDB'yi hem snapshot katmanını atlar (forceFresh anlamı
    // korunur): kullanıcı ücret uyarısını onayladıysa gerçekten canlıya gidilir.
    const istek = tazele ? this.$uyap.BorcluSgkHaciz().fresh() : this.$uyap.BorcluSgkHaciz();
    let items = await istek.run(talep);
    this.cevap = items;
    if (items.sorguSonucu && items.sorguSonucDVO)
      this.items = items.sorguSonucDVO;
  }

  /** Ücret uyarısı onaylandıktan sonra çağrılır (SorguKaynakRozeti). */
  async yenile() {
    if (this.yenileniyor) {
      return;
    }
    this.yenileniyor = true;
    try {
      await this.load(true);
    } catch (e: any) {
      this.$toast.error(e.message || "Sorgu yenilenemedi.");
    } finally {
      this.yenileniyor = false;
    }
  }
}
